export default __webpack_public_path__ + "static/media/logo-13-adiwana-hotels.c9fbf570.png";